import React from "react";
import { Navigate, useLocation } from "react-router-dom";
export default function SalesFunnelPage() {
  const location = useLocation();
  return <Navigate replace to={{ pathname: "/contacts", search: location.search }} />;
}
